import React, { useState } from 'react'

import { myWalletCurrencies } from '../../../../../constants'

const WithdrawingWallet = () => {
  const [currency, setCurrency] = useState(myWalletCurrencies[0].value)

  const handleCurrencyChange = (value) => {
    setCurrency(value)
  }

  const handleWithdraw = () => {}

  const myWalletCurrenciesContent = myWalletCurrencies.map((walletCurrency) => {
    return (
      <button
        key={walletCurrency.icon}
        className={`w-[48px] h-[48px] opacity-70 hover:opacity-100 ${currency === walletCurrency.value ? '!opacity-100' : ''}`}
        onClick={() => handleCurrencyChange(walletCurrency.value)}
      >
        <img
          className={`inline-block w-full h-full !border-2 border-transparent rounded-circle ${currency === walletCurrency.value ? '!border-primary-300' : ''}`}
          src={walletCurrency.icon}
          alt={walletCurrency.value}
          draggable={false}
        />
      </button>
    )
  })

  return (
    <div className="w-full mt-[20px]">
      <h4 className="text-center text-3xl leading-[20px] text-primary-100 font-semibold">
        My Wallet
      </h4>

      <div className="w-full flex items-center justify-center gap-x-[4px] mt-[14px]">
        {myWalletCurrenciesContent}
      </div>

      <div className="flex items-center justify-between mt-[10px] bg-white rounded-[10px] border-[#FFE4D4] border-[1px] p-[20px]">
        <div className="flex flex-col">
          <span className="text-xl font-medium text-primary-100">Euro</span>

          <span className="font-bold text-primary-100 text-[24px] leading-[34px] mt-[4px]">
            € 106.03
          </span>
        </div>

        <button
          className="shadow-button rounded-[8px] bg-[#F79009] border-[#FFCA84] border-[1px] px-[14px] h-[44px] flex items-center text-base font-bold text-white"
          onClick={handleWithdraw}
        >
          Withdraw
        </button>
      </div>
    </div>
  )
}

export default WithdrawingWallet
